import { useCallback, useRef } from "react";
import { splitIntoChunks } from "../utils/textUtils";

export const useTTS = () => {
  const isSpeakingRef = useRef(false);
  const speakTokenRef = useRef(0);
  const speakingPromiseRef = useRef(Promise.resolve());

  const speak = useCallback(
    async ({ text, setIsSpeaking = null, setIsError = null }) => {
      if (!text) return;

      const chunks = splitIntoChunks(text);
      const voices = speechSynthesis.getVoices();
      const voice =
        voices.find((voice) => voice.name === "Google UK English Male") ||
        voices.find((voice) => voice.name === "Samantha") ||
        voices.find(
          (voice) =>
            voice.name.includes("Guy") && voice.name.includes("Online"),
        ) ||
        voices[0];

      const currentToken = speakTokenRef.current + 1;
      speakTokenRef.current = currentToken;

      speechSynthesis.cancel();
      isSpeakingRef.current = true;
      if (setIsSpeaking) setIsSpeaking(true);

      const speakPromise = (async () => {
        try {
          for (let index = 0; index < chunks.length; index++) {
            // 중단 요청 또는 최신 발화가 아니면 재생 중단
            if (
              !isSpeakingRef.current ||
              currentToken !== speakTokenRef.current
            )
              break;

            const chunk = chunks[index];
            await new Promise((resolve, reject) => {
              const utterance = new SpeechSynthesisUtterance(chunk);
              utterance.voice = voice || null;
              utterance.lang = "en-US";
              if (voice && voice.name === "Samantha") utterance.rate = 0.6;
              else utterance.rate = 0.8;
              utterance.pitch = 1;

              utterance.onend = () => {
                resolve();
              };

              utterance.onerror = (error) => {
                if (setIsError) setIsError(error);
                reject(error);
              };

              speechSynthesis.speak(utterance);
            });
          }
        } catch (error) {
          console.error("Speech synthesis error:", error);
        } finally {
          if (currentToken === speakTokenRef.current) {
            isSpeakingRef.current = false;
            if (setIsSpeaking) setIsSpeaking(false);
          }
        }
      })();

      speakingPromiseRef.current = speakPromise;
      await speakPromise;
    },
    [],
  );

  const stopSpeaking = useCallback(() => {
    isSpeakingRef.current = false; // 중단 요청
    speakTokenRef.current += 1;
    speechSynthesis.cancel();
  }, []);

  const waitForCurrentSpeech = useCallback(async () => {
    await speakingPromiseRef.current;
  }, []);

  return { speak, stopSpeaking, waitForCurrentSpeech };
};
